module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/franchising/vantaggio_appuntamenti.9cc592e7a2bcbde192a19367bf51bc9b.jpg";